import React from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ContextMenu.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

// `portal` renders the menu into document.body instead of inline. Callers that
// position the menu with document-level coordinates (pageX/pageY) and expect it
// to overlay the whole page should set this — otherwise a positioned/offset
// ancestor (e.g. the new-nav fixed header) becomes its containing block and
// stacking context, throwing off both placement and z-order.
function ContextMenu({ menuItems, style, portal = false }) {
  const menu = (
    <div className="context-menu-container" style={style}>
      <ul className="context-menu">
        {menuItems.map((menuItem, index) => {
          const menuContent = (
            <div key={index}>
              <li
                className={`context-menu-item ${
                  menuItem.disabled ? "disabled-context-menu-item" : ""
                }`}
              >
                {menuItem.disabled ? (
                  <span>
                    {menuItem.iconClass && (
                      <FontAwesomeIcon
                        icon={menuItem.iconClass}
                        style={menuItem.style}
                      />
                    )}
                    {menuItem.name}
                  </span>
                ) : (
                  <a
                    href={menuItem.href ? menuItem.href : null}
                    target={menuItem.newTab ? "_blank" : ""}
                    onClick={menuItem.onClick}
                  >
                    {menuItem.iconClass && (
                      <FontAwesomeIcon
                        icon={menuItem.iconClass}
                        style={menuItem.style}
                      />
                    )}
                    {menuItem.name}
                  </a>
                )}
              </li>
            </div>
          );
          return (
            <div key={index}>
              {menuItem.disabled && menuItem.tooltip ? (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id={`tooltip-${index}`}>
                      {menuItem.tooltip}
                    </Tooltip>
                  }
                >
                  {menuContent}
                </OverlayTrigger>
              ) : (
                menuContent
              )}
              {menuItem.hasBreakingLine ? <hr /> : null}
            </div>
          );
        })}
      </ul>
    </div>
  );

  return portal ? createPortal(menu, document.body) : menu;
}

export default ContextMenu;
